import React from 'react';
import AppHeader from './AppHeader';
import {
  canAccessCompensation,
  canAccessUserManagement,
} from '../utils/roles';

function Dashboard({ user, onLogout, onNavigate }) {
  const cards = [
    {
      id: 'cases',
      title: 'Cases',
      body: 'Track guest questions, own work, and post updates.',
      primary: true,
    },
    {
      id: 'search',
      title: 'Search',
      body: 'Find past guest interactions by name, email, or ticket.',
    },
    {
      id: 'submit',
      title: 'New submission',
      body: 'Log a resolved guest interaction and compensation.',
    },
    {
      id: 'season-pass',
      title: 'Season Pass',
      body: 'Open passholder profiles with cases and compensation history.',
    },
    {
      id: 'orders',
      title: 'Orders',
      body: 'Create and look up ticket and season pass orders.',
    },
  ];

  if (canAccessCompensation(user)) {
    cards.push({
      id: 'compensation',
      title: 'Compensation options',
      body: 'Manage resolution choices available at your location.',
    });
  }
  if (canAccessUserManagement(user)) {
    cards.push({
      id: 'users',
      title: 'Administration',
      body: 'Manage users and park locations.',
    });
  }

  return (
    <div className="container wide-container app-shell">
      <AppHeader
        user={user}
        pageTitle="Home"
        subtitle={user?.name ? `Welcome back, ${user.name}` : 'Welcome'}
        onNavigate={onNavigate}
        onLogout={onLogout}
        active="dashboard"
      />

      <div className="dashboard-grid">
        {cards.map((card) => (
          <button
            key={card.id}
            type="button"
            className={`dashboard-card${card.primary ? ' primary' : ''}`}
            onClick={() => onNavigate(card.id)}
          >
            <span className="dashboard-card-title">{card.title}</span>
            <span className="dashboard-card-body">{card.body}</span>
          </button>
        ))}
      </div>
    </div>
  );
}

export default Dashboard;
